<template>
  <logo-layout 
    :title="$t('pages.incrustado.aviso')"
    :description="reservaUsuario ? 
      getTexto('error.reservado') :
      getTexto('error.noDisponible')"
  >
    <v-layout justify-center v-if="reservaUsuario && mostrarBoton">
      <v-btn target="_top" color="primary" :href="rutaPortal">
        {{$t('incrustado.portalCD')}}
      </v-btn>
    </v-layout>
  </logo-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['reservaUsuario'],
  computed: {
    ...mapGetters({
      codSubdominioAgrupacion: 'login/codSubdominioAgrupacion'
    }),
    rutaPortal () {
      return this.$router.resolve({
        name: 'loginParam',
        params: { 
          codigoSubdominio: this.codSubdominioAgrupacion
        }
      }).href
    },
    mostrarBoton () {
      return window.mostrarBoton
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/incrustado/mensajeReservado.vue